import { apiService } from "./apiService";
import { getAccessToken } from "./authService";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3000/api";

const buildQueryString = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "" || value === "all") {
      return;
    }
    params.append(key, value);
  });
  const query = params.toString();
  return query ? `?${query}` : "";
};

export const getActivityLogs = async (filters = {}) => {
  return apiService.request(`/client-admin/activity${buildQueryString(filters)}`, {
    method: "GET",
  });
};

export const getActivityActors = async () => {
  return apiService.request("/client-admin/activity/actors", { method: "GET" });
};

export const exportActivityLogs = async (filters = {}) => {
  const token = getAccessToken();
  const response = await fetch(
    `${API_BASE_URL}/client-admin/activity/export${buildQueryString(filters)}`,
    {
      method: "GET",
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }
  );

  if (!response.ok) {
    throw new Error("Failed to export activity logs");
  }

  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = `activity-log-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
};
